import { useEffect } from 'react'

import styles from './styles/StudentsPanel.css'
import TalkToUs from './TalkToUs'
import PartnerValueProp from './PartnerValueProp'
import PartnersPanel from './PartnersPanel'
import AwardsAndPress from './Awards'
import PluginButton from '../misc/PluginButton'
import P from 'components/typography/Paragraph'
import * as analytics from 'lib/analytics'
import Endorsements from '../home/Endorsements'
import Button from '../forms/Button'
import classNames from 'classnames'
import Link from '../misc/Link'

const StudentsPanel = () => {
  useEffect(() => {
    analytics.event({
      category: 'Partners',
      action: 'View Students Partners Page'
    })
  }, [])

  return (
    <div className={styles.layout}>
      <TalkToUs
        header={false}
        cta={
          <a href='https://help.scite.ai/en-us/article/writing-a-paper-with-scite-nzgfms' target='_blank' rel='noopener noreferrer'>
            <Button className={classNames(styles.submitBtn, styles.transparentBtn)} color='transparent'>Use scite to write a paper</Button>
          </a>
        }
        contactCopy='Get student discount'
        subheader={
          <>
            Write a term paper, thesis proposal, lab report, literature review or critical analysis faster and eaiser than you ever have before. Get a 30% student discount off any of our plans! You can also make money by sharing scite with your freinds, <Link underline to='/affiliate'>click here for details.</Link>
          </>
        }
      />
      <PartnerValueProp
        className={styles.valueProp}
        id='search-citations'
        header='Know exactly what you should be citing'
        cta='Search Citation Statements'
        ctaLocation='/search/citations'
        link='Learn how to do a literature review or critical analysis with scite'
        linkLocation='https://help.scite.ai/en-us/article/using-scite-for-literature-reviews-and-critical-analysis-1bgeq8/'
      >
        <P>
          Never waste time looking for what research you should cite. Search over {CONFIG.defaultCitationsTotalText} citation statements and find citations and well supported literature for your research projects.
        </P>
        <img alt='citation-statement-search' src={`${CONFIG.assetsBaseURL}/images/citation-statement-search.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='power-of-scite'
        header='Understand which articles are well supported'
      >
        <P>
          How can you tell if an article is well supported and worth reading?
          The scite browser extension for Chrome, Firefox, or Safari allows you to easily see if articles have been supported or contrasted anywhere you’re reading online. It’s like having hundreds of millions of pieces of evidence on virtually any topic you’re interested in available to you only a click away.
        </P>
        <img alt='plugin' src={`${CONFIG.assetsBaseURL}/images/illustrations/page-badge-snippet-2.svg?v=1`} />
        <PluginButton className={styles.plugin} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='scite-cite'
        header='scite before you cite'
        cta='Try Reference Check'
        ctaLocation='/?referenceCheck=true'
      >
        <P>
          Writing a research paper? The scite Reference Check allows you to easily upload your research articles to see how the references you’re citing have been cited by others. Ensure that you are citing reliable work by screening against retracted references and check to see if others have contrasted your references.
        </P>
        <img alt='reference-check' src={`${CONFIG.assetsBaseURL}/images/illustrations/reference-check.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='literature-review'
        header='A better way to do a literature review'
        cta='View Visualizations'
        ctaLocation='/visualizations/global-analysis-of-genome-transcriptome-9L4dJr?dois[0]=10.1038%2Fmsb.2012.40&dois[1]=10.7554%2Felife.05068&focusedElement=10.7554%2Felife.05068'
      >
        <P>
          Visualize how scientific articles cite each other through scite Visualizations. Visualizations allows you to better discover and evaluate scientific articles through an interactive citation network.
        </P>
        <img alt='visualizations' src={`${CONFIG.assetsBaseURL}/images/illustrations/visualizations-illo.png?v=1`} />
      </PartnerValueProp>
      <PartnersPanel header='Who we’re working with' />
      <AwardsAndPress />
      <Endorsements />
      <TalkToUs />
    </div>
  )
}

export default StudentsPanel
